import clsx from 'clsx';
import DallasFlex from '../Stack/DallasFlex';
import DallasText from '../Text/DallasText';
import DallasStack from '~/app/_ui/Dallas/Stack/DallasStack';

import styles from './DallasBanner.module.scss';

export type BannerColor =
  | 'default'
  | 'success'
  | 'warning'
  | 'error'
  | 'neutral';

export interface Props {
  className?: string;
  color: BannerColor;
  text?: string;
  content?: React.ReactElement;
  addOnStart?: React.ReactElement;
  addOnEnd?: React.ReactElement;
}

export default function DallasBanner({
  className,
  text,
  content,
  color,
  addOnStart,
  addOnEnd,
}: Props) {
  return (
    <DallasStack
      className={clsx(className, styles.root, styles[`color-${color}`])}
      gap="xs"
      direction="row"
      alignVertical="center"
      alignHorizontal="start"
      paddingVertical="xs"
      paddingHorizontal="xs"
    >
      {addOnStart && <div className={styles.addOnWrapper}>{addOnStart}</div>}
      <DallasFlex>
        {text && <DallasText>{text}</DallasText>}
        {content && <div>{content}</div>}
      </DallasFlex>
      {addOnEnd && <div className={styles.addOnWrapper}>{addOnEnd}</div>}
    </DallasStack>
  );
}
